export class TravelDetailModel {
  tdId: string;
  tdPurpose: string;
  tdType: string;
  tdCarrier: string;
  tdGroup: string;
  tdAdultsNumber: string;
  tdChildrenNumber: string;
  tdFrom: string;
  tdTo: string;
  tdStartDate: Date;
  tdGoingFlightNumber: string;
  tdIsReturnBooked: boolean;
  tdReturnDate: Date;
  tdReturnFlightNumber: string;
  tdBookingNumber: string;
  tdIsTicketChangeable: Boolean;
  tdBookingAgency: string;
  tdBookingAgencyPhoneNumber: string;
  tdTourOperator: string;
  tdTravelPlan: string;
  tdAssignmentId: string;
}